module.exports = __webpack_public_path__ + "img/affinity_bank.png";